(() => {
  const GIFT_VARIANT_ID = 53963225268565;
  const QUALIFYING_VARIANT_ID = 52353425506645;
  const QUALIFYING_SELLING_PLAN_ID = 691220349269;

  let isSyncing = false;
  let needsResync = false;
  let syncTimer = null;

  const getCartDrawer = () => document.querySelector('cart-drawer');

  const getSections = () => {
    const cartDrawer = getCartDrawer();

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return cartDrawer.getSectionsToRender().map((section) => section.id);
    }

    return ['cart-drawer', 'cart-icon-bubble'];
  };

  const scheduleSync = ({ openDrawer = false, delay = 250 } = {}) => {
    clearTimeout(syncTimer);

    syncTimer = setTimeout(() => {
      syncAnnualGift({ openDrawer });
    }, delay);
  };

  const refreshCartDrawer = async (openDrawer = false) => {
    const cartDrawer = getCartDrawer();

    const response = await fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        updates: {},
        sections: getSections(),
        sections_url: window.location.pathname,
      }),
    });

    const data = await response.json();

    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(data, !openDrawer);
    }

    if (openDrawer && cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  };

  const getCart = async () => {
    const response = await fetch(`${window.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' },
    });

    return response.json();
  };

  const isAnnualSubscriptionItem = (item) => {
    const sellingPlanId =
      item.selling_plan_allocation?.selling_plan?.id ||
      item.selling_plan_allocation?.selling_plan_id;

    return (
      Number(item.variant_id) === QUALIFYING_VARIANT_ID &&
      Number(sellingPlanId) === QUALIFYING_SELLING_PLAN_ID
    );
  };

  const getGiftItems = (cart) => {
    return cart.items.filter((item) => Number(item.variant_id) === GIFT_VARIANT_ID);
  };

  const addGift = async () => {
    await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: {
              _free_gift: '12-Monats-Abo',
            },
          },
        ],
      }),
    });
  };

  const removeGiftItem = async (giftItem) => {
    await fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: giftItem.key,
        quantity: 0,
      }),
    });
  };

  const changeGiftQuantity = async (giftItem, quantity) => {
    await fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: giftItem.key,
        quantity,
      }),
    });
  };

  const syncAnnualGift = async ({ openDrawer = false } = {}) => {
    if (isSyncing) {
      needsResync = true;
      return;
    }

    isSyncing = true;
    needsResync = false;

    try {
      const cart = await getCart();

      const hasAnnualSubscription = cart.items.some(isAnnualSubscriptionItem);
      const giftItems = getGiftItems(cart);

      let cartChanged = false;

      if (!hasAnnualSubscription) {
        for (const giftItem of giftItems) {
          await removeGiftItem(giftItem);
          cartChanged = true;
        }

        if (cartChanged) {
          await refreshCartDrawer(openDrawer);
        }

        return;
      }

      if (giftItems.length === 0) {
        await addGift();
        await refreshCartDrawer(openDrawer);
        return;
      }

      if (giftItems.length > 1) {
        for (const giftItem of giftItems) {
          await removeGiftItem(giftItem);
        }

        await addGift();
        await refreshCartDrawer(openDrawer);
        return;
      }

      const giftItem = giftItems[0];

      if (giftItem.quantity !== 1) {
        await changeGiftQuantity(giftItem, 1);
        await refreshCartDrawer(openDrawer);
        return;
      }
    } catch (error) {
      console.error('Annual gift sync failed:', error);
    } finally {
      isSyncing = false;

      if (needsResync) {
        scheduleSync({ openDrawer: false, delay: 250 });
      }
    }
  };

  window.MatchaAnnualGift = {
    sync: syncAnnualGift,
  };

  document.addEventListener('DOMContentLoaded', () => {
    syncAnnualGift();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;

    if (!form.matches('form[action*="/cart/add"]')) return;

    if (form.matches('[data-annual-gift-form]')) {
      event.preventDefault();

      try {
        await fetch(window.routes.cart_add_url, {
          method: 'POST',
          body: new FormData(form),
        });

        await syncAnnualGift({ openDrawer: true });
      } catch (error) {
        console.error('Annual ABO add failed:', error);
      }

      return;
    }

    scheduleSync({ openDrawer: true, delay: 800 });
  });

  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';

    if (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes(window.routes.cart_add_url) ||
      url.includes(window.routes.cart_change_url) ||
      url.includes(window.routes.cart_update_url)
    ) {
      scheduleSync({ openDrawer: false, delay: 300 });
    }

    return response;
  };
})();